// ====== DYNAMIC STICKY CTA ======
  // Copy adapts to user's scroll position - matches mental state at each stage
  const stickyCta = document.getElementById('stickyCta');
  const stickyBtn = document.getElementById('stickyBtn');
  const stickyMeta = document.getElementById('stickyMeta');

  const hero = document.querySelector('.hero');
  const sections = {
    creds: document.querySelector('.creds'),
    symptoms: document.querySelector('.symptoms'),
    catalog: document.querySelector('.catalog'),
    bestsellers: document.querySelector('.bestsellers'),
    supplements: document.querySelector('.supplements'),
    reviews: document.querySelector('.reviews'),
    compare: document.querySelector('.compare'),
    workaround: document.querySelector('.workaround'),
    faq: document.querySelector('.faq'),
    finalCta: document.querySelector('.final-cta'),
  };

  // Stages tied to scroll position - copy reflects user's mental state at each point
  const stages = [
    {key:'default',     btn:'Tell us what\'s going on',         meta:'<strong>Refunded</strong> if not prescribed <span class="sep">·</span> 48 hours <span class="sep">·</span> <strong>4.8★</strong>'},
    {key:'creds',       btn:'Tell us what\'s going on',         meta:'<strong>Clinician review</strong> <span class="sep">·</span> Refunded if not prescribed'},
    {key:'symptoms',    btn:'See what we\'d prescribe',         meta:'Match in <strong>90 sec</strong> <span class="sep">·</span> No card to see match'},
    {key:'catalog',     btn:'Get matched to your protocol',     meta:'<strong>50 protocols</strong> <span class="sep">·</span> Clinician-reviewed before fulfillment'},
    {key:'bestsellers', btn:'Find what fits you',               meta:'<strong>Clinician reviewed</strong> <span class="sep">·</span> patient feedback'},
    {key:'supplements', btn:'See your protocol match',          meta:'<strong>Auto-applied 20% off</strong> first supplement order'},
    {key:'reviews',     btn:'Read patient feedback',            meta:'<strong>4.8★</strong> <span class="sep">·</span> qualitative reviews'},
    {key:'compare',     btn:'Try Amie risk-aware',               meta:'<strong>Refunded within 48 hours</strong> if not prescribed <span class="sep">·</span> Cancel one click'},
    {key:'workaround',  btn:'Stop the workaround spiral',       meta:'<strong>$179/mo</strong> vs <strong>$1,898/mo</strong> on workarounds'},
    {key:'faq',         btn:'Last question? Start here',        meta:'<strong>Clinician reviewed</strong> <span class="sep">·</span> Refunded within 48 hours if declined'},
    {key:'finalCta',    btn:'Yes — find my match',              meta:'<strong>Free</strong> <span class="sep">·</span> 90 sec <span class="sep">·</span> No card to see match'},
  ];

  let currentStage = 0;
  let isUpdating = false;

  function checkSticky(){
    // Show/hide sticky based on hero scroll
    const heroBottom = hero.getBoundingClientRect().bottom;
    if (heroBottom < 0){
      stickyCta.classList.add('visible');
    } else {
      stickyCta.classList.remove('visible');
      return;
    }

    // Determine current stage - find the deepest section the user has scrolled past
    // (top of section is in the upper 60% of viewport)
    let stage = 0;
    const triggerPoint = window.innerHeight * 0.6;

    for (let i = 1; i < stages.length; i++){
      const sectionKey = stages[i].key;
      const sec = sections[sectionKey];
      if (sec && sec.getBoundingClientRect().top < triggerPoint){
        stage = i;
      }
    }

    // Update copy if stage changed
    if (stage !== currentStage && !isUpdating){
      currentStage = stage;
      isUpdating = true;
      stickyMeta.style.opacity = 0;
      setTimeout(() => {
        stickyBtn.innerHTML = stages[stage].btn + ' <span class="arrow-c">→</span>';
        stickyMeta.innerHTML = stages[stage].meta;
        stickyMeta.style.opacity = 1;
        isUpdating = false;
      }, 200);
    }
  }
  window.addEventListener('scroll', checkSticky, {passive:true});
  window.addEventListener('resize', checkSticky);

  // Carousel progress dots
  const carousel = document.getElementById('symptomCarousel');
  const dots = document.querySelectorAll('#carouselProgress .progress-dot');
  carousel.addEventListener('scroll', () => {
    const cardWidth = carousel.querySelector('.sym-card').offsetWidth + 14;
    const idx = Math.round(carousel.scrollLeft / cardWidth);
    dots.forEach((d, i) => d.classList.toggle('active', i === idx));
  }, {passive:true});

  // Comparison carousel - tab + scroll sync, default to Amie (idx 1)
  const cmpCarousel = document.getElementById('cmpCarousel');
  const cmpTabs = document.querySelectorAll('.cmp-tab');
  const cmpDots = document.querySelectorAll('.cmp-progress .progress-dot');

  function setCmpActive(idx){
    cmpTabs.forEach((t, i) => t.classList.toggle('active', i === idx));
    cmpDots.forEach((d, i) => d.classList.toggle('active', i === idx));
  }

  // Tab click → scroll to card
  cmpTabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const idx = parseInt(tab.dataset.target);
      const cardWidth = cmpCarousel.querySelector('.cmp-card').offsetWidth + 14;
      cmpCarousel.scrollTo({left: cardWidth * idx, behavior:'smooth'});
    });
  });

  // Scroll → update tab/dot
  cmpCarousel.addEventListener('scroll', () => {
    const cardWidth = cmpCarousel.querySelector('.cmp-card').offsetWidth + 14;
    const idx = Math.round(cmpCarousel.scrollLeft / cardWidth);
    setCmpActive(idx);
  }, {passive:true});

  // Default to Amie card on load
  window.addEventListener('load', () => {
    const cardWidth = cmpCarousel.querySelector('.cmp-card').offsetWidth + 14;
    cmpCarousel.scrollLeft = cardWidth * 1;
  });
;
(function(){var root=document.querySelector('[data-amie-liquid-homepage]');if(!root)return;var catalog=[['Rest','/products/rest','Treatment'],['Spark','/products/spark','Treatment'],['NAD+','/products/nad-plus','Treatment'],['Sermorelin','/products/sermorelin-vial','Treatment'],['Ember','/products/ember-female-libido-booster','Supplement'],['Grace','/products/grace-menopause-supplement','Supplement'],['All supplements','/supplements','Collection'],['Treatments','/collections/treatments','Collection'],['How it works','/how-it-works','Guide'],['Reviews','/reviews','Proof'],['Editorial','/editorial','Articles']];var overlay=root.querySelector('[data-search-overlay]'),input=root.querySelector('[data-search-input]'),results=root.querySelector('[data-search-results]');function render(q){if(!results)return;q=(q||'').toLowerCase();var hits=catalog.filter(function(i){return !q||(i[0]+' '+i[2]).toLowerCase().indexOf(q)>=0}).slice(0,8);results.innerHTML=hits.length?hits.map(function(i){return '<a class="site-search-result" href="'+i[1]+'"><span>'+i[0]+'</span><em>'+i[2]+'</em></a>'}).join(''):'<div class="site-search-empty">No matching pages. Try Spark, GLP-1, Ember, or menopause.</div>'}function openSearch(){if(!overlay)return;overlay.setAttribute('data-open','true');render(input&&input.value);setTimeout(function(){input&&input.focus()},20)}function closeSearch(){overlay&&overlay.setAttribute('data-open','false')}root.querySelectorAll('[data-search-open]').forEach(function(b){b.addEventListener('click',openSearch)});root.querySelectorAll('[data-search-close]').forEach(function(b){b.addEventListener('click',closeSearch)});input&&input.addEventListener('input',function(){render(input.value)});render('');var panel=root.querySelector('#site-mobile-menu'),toggle=root.querySelector('[data-mobile-toggle]'),label=root.querySelector('[data-menu-label]');toggle&&toggle.addEventListener('click',function(){var open=panel&&panel.getAttribute('data-open')==='true';panel&&panel.setAttribute('data-open',open?'false':'true');toggle.setAttribute('aria-expanded',open?'false':'true');if(label)label.textContent=open?'Menu':'Close'});var keys=['gclid','gbraid','wbraid','utm_source','utm_medium','utm_campaign','utm_term','utm_content','msclkid','fbclid','ttclid'];var params=new URLSearchParams(window.location.search);if(keys.some(function(k){return params.has(k)})){root.querySelectorAll('a[href^="/products/"],a[href^="/pages/quiz-start"],a[href^="/quiz"]').forEach(function(a){try{var u=new URL(a.getAttribute('href'),window.location.origin);keys.forEach(function(k){if(params.has(k)&&!u.searchParams.has(k))u.searchParams.set(k,params.get(k))});a.setAttribute('href',u.pathname+u.search+u.hash)}catch(e){}})}})();